export default __webpack_public_path__ + "static/media/settings.5e6ec7c5.svg";